import {
  type Chain,
  arbitrum as arbitrumOne,
  arbitrumSepolia,
  base,
  baseSepolia,
  bsc as bscMainnet,
  bscTestnet,
  mainnet as ethereum,
  opBNB as opBNBMainnet,
  opBNBTestnet,
  optimism as optimismMainnet,
  optimismSepolia,
  sepolia,
  unichain,
  unichainSepolia,
  zksync as zksyncMainnet,
  zksyncSepoliaTestnet,
} from 'wagmi/chains';

import { ChainId } from '../../types';

const subtensorEvm = {
  id: ChainId.BITTENSOR_MAINNET,
  name: 'Bittensor EVM',
  nativeCurrency: {
    name: 'TAO',
    symbol: 'TAO',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://lite.chain.opentensor.ai'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Taostats EVM Explorer',
      url: 'https://evm.taostats.io',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
  },
} as const satisfies Chain;

const subtensorEvmTestnet = {
  id: ChainId.BITTENSOR_TESTNET,
  name: 'Bittensor EVM Testnet',
  nativeCurrency: {
    name: 'TAO',
    symbol: 'TAO',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://test.chain.opentensor.ai'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Subtensor EVM Testnet Explorer',
      url: 'https://evm-testscan.dev.opentensor.ai',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
  },
} as const satisfies Chain;

const localAnvil = {
  id: ChainId.LOCAL,
  name: 'Local Anvil',
  nativeCurrency: {
    name: 'TAO',
    symbol: 'TAO',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['http://127.0.0.1:8545'],
    },
  },
} as const satisfies Chain;

export const viemChains: Record<ChainId, Chain> = {
  [ChainId.LOCAL]: localAnvil,
  [ChainId.BSC_MAINNET]: bscMainnet,
  [ChainId.BSC_TESTNET]: bscTestnet,
  [ChainId.ETHEREUM]: ethereum,
  [ChainId.SEPOLIA]: sepolia,
  [ChainId.OPBNB_MAINNET]: opBNBMainnet,
  [ChainId.OPBNB_TESTNET]: opBNBTestnet,
  [ChainId.ARBITRUM_ONE]: arbitrumOne,
  [ChainId.ARBITRUM_SEPOLIA]: arbitrumSepolia,
  [ChainId.ZKSYNC_MAINNET]: zksyncMainnet,
  [ChainId.ZKSYNC_SEPOLIA]: zksyncSepoliaTestnet,
  [ChainId.OPTIMISM_MAINNET]: optimismMainnet,
  [ChainId.OPTIMISM_SEPOLIA]: optimismSepolia,
  [ChainId.BASE_MAINNET]: base,
  [ChainId.BASE_SEPOLIA]: baseSepolia,
  [ChainId.BITTENSOR_MAINNET]: subtensorEvm,
  [ChainId.BITTENSOR_TESTNET]: subtensorEvmTestnet,
  [ChainId.UNICHAIN_MAINNET]: unichain,
  [ChainId.UNICHAIN_SEPOLIA]: unichainSepolia,
};
